import React from 'react';
import Select, { OptionTypeBase } from 'react-select';
import { useTranslation } from 'react-i18next';

interface TimeSelectProps {
  name: string;
  value?: string;
  // todo: must be fixed
  onChange: (e: any) => void;
}

const TimeSelect = ({ name, value, ...props }: TimeSelectProps) => {
  const { t } = useTranslation();

  const options: Array<OptionTypeBase> = [];
  for (let i = 7; i <= 22; i += 1) {
    options.push({
      value: `${i.toString().padStart(2, '0')}:00:00`,
      label: `${i}:00`,
    });
    options.push({
      value: `${i.toString().padStart(2, '0')}:30:00`,
      label: `${i}:30`,
    });
  }

  const onChange = (selected: OptionTypeBase) => {
    props.onChange({
      target: {
        name,
        value: selected.value,
      },
    });
  };

  return (
    <Select
      name={name}
      value={options.find((o: OptionTypeBase) => o.value === value)}
      options={options}
      placeholder={t('FORMS.SELECT')}
      onChange={onChange}
    />
  );
};

export default TimeSelect;
